import type { PaletteConfig } from '@plentymarkets/tailwind-colors';
import { createPaletteFromColor } from '@plentymarkets/tailwind-colors';
import type { RGB, TailwindPalette } from './types';

const hex2rgb = (hex: string): RGB => {
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);

  return { r, g, b };
};

export const getPaletteFromColor = (type: string, hexColor: string, config: PaletteConfig = {}): TailwindPalette => {
  const paletteOutput = createPaletteFromColor(type, hexColor, config);
  const rgbPalette: TailwindPalette = [];

  if (!paletteOutput || !paletteOutput[type]) {
    return rgbPalette;
  }

  Object.entries(paletteOutput[type]).forEach((entry) => {
    const rgb = hex2rgb(entry[1]) || '';
    rgbPalette.push({ weight: entry[0], rgb: `${rgb.r} ${rgb.g} ${rgb.b}` });
  });
  return rgbPalette;
};

export const setColorProperties = (type: string, tailwindPalette: TailwindPalette) => {
  tailwindPalette.forEach((shade) => {
    if (shade.rgb) {
      document.documentElement.style.setProperty(`--colors-2-${type}-${shade.weight}`, shade.rgb);
    }
  });
};
